// Generated by radium backend
// timestamp: 2023-11-22T14:06:25.755Z

// datastructure enums

// datastructure: Address
// no enums defined in this datastructure

// datastructure: Article
export enum Article_InventoryType {
  static = "static",
  journal = "journal",
}

// datastructure: ArticleCategory
// no enums defined in this datastructure

// datastructure: ArticleParameter
// no enums defined in this datastructure

// datastructure: ArticlePrice
// no enums defined in this datastructure

// datastructure: ArticlePriceTier
// no enums defined in this datastructure

// datastructure: ArticleSource
// no enums defined in this datastructure

// datastructure: Customer
// no enums defined in this datastructure

// datastructure: CustomerContact
// no enums defined in this datastructure

// datastructure: CustomerOrder
export enum CustomerOrder_State {
  accepted = "accepted",
  processing = "processing",
  ready_for_pickup = "ready_for_pickup",
  wait_for_reply = "wait_for_reply",
  wait_for_parts = "wait_for_parts",
  pickedup = "pickedup",
  canceled = "canceled",
}

export enum CustomerOrder_Type {
  repair = "repair",
  part_order = "part_order",
  inquiry = "inquiry",
}

// datastructure: CustomerOrderPosition
export enum CustomerOrderPosition_Type {
  article = "article",
  manual_position = "manual_position",
  text_position = "text_position",
}

// datastructure: DeliveryNote
// no enums defined in this datastructure

// datastructure: DeliveryNotePosition
export enum DeliveryNotePosition_Type {
  article = "article",
  manual_position = "manual_position",
  text_position = "text_position",
}

// datastructure: Distributor
// no enums defined in this datastructure

// datastructure: Footprint
export enum Footprint_Type {
  SMD = "SMD",
  THT = "THT",
  None = "None",
}

// datastructure: FootprintMeta
export enum FootprintMeta_Key {
  PAPImport = "PAPImport",
  PAPExport = "PAPExport",
  Alias = "Alias",
}

// datastructure: InventoryEntry
// no enums defined in this datastructure

// datastructure: Invoice
export enum Invoice_State {
  open = "open",
  paid = "paid",
}

// datastructure: InvoicePosition
export enum InvoicePosition_Type {
  article = "article",
  manual_position = "manual_position",
  text_position = "text_position",
}

// datastructure: KeyField
export enum KeyField_Type {
  float = "float",
  text = "text",
  select = "select",
}

// datastructure: Location
// no enums defined in this datastructure

// datastructure: Offer
// no enums defined in this datastructure

// datastructure: OfferPosition
export enum OfferPosition_Type {
  article = "article",
  manual_position = "manual_position",
  text_position = "text_position",
}

// datastructure: Order
export enum Order_OrderType {
  order = "order",
  confirmed_order_of_qty = "confirmed_order_of_qty",
}

export enum Order_State {
  open = "open",
  onfirmed = "onfirmed",
  partial_delivery = "partial_delivery",
  delivered = "delivered",
  invoiced = "invoiced",
  closed = "closed",
}

// datastructure: OrderPosition
export enum OrderPosition_Type {
  article = "article",
  manual_position = "manual_position",
  text_position = "text_position",
}

// datastructure: PNPFile
export enum PnpFile_EcadUnit {
  mm = "mm",
  mil = "mil",
}

// datastructure: PNPFileEntry
export enum PnpFileEntry_EntryMode {
  manual = "manual",
  part = "part",
}

// datastructure: PaymentCondition
// no enums defined in this datastructure

// datastructure: ProductGroup
// no enums defined in this datastructure

// datastructure: Project
// no enums defined in this datastructure

// datastructure: ProjectConfiguration
// no enums defined in this datastructure

// datastructure: Receipt
// no enums defined in this datastructure

// datastructure: ReceiptPosition
export enum ReceiptPosition_Type {
  article = "article",
  manual_position = "manual_position",
  text_position = "text_position",
}

// datastructure: Role
// no enums defined in this datastructure

// datastructure: SupplyOrder
export enum SupplyOrder_State {
  open = "open",
  ordered = "ordered",
  in_progress = "in_progress",
  closed = "closed",
}

// datastructure: SupplyOrderPosition
// no enums defined in this datastructure

// datastructure: SupplyOrderReceipt
// no enums defined in this datastructure

// datastructure: Permission
// no enums defined in this datastructure

// datastructure: User
// no enums defined in this datastructure

// datastructure: Transaction
export enum Transaction_ObjectType {
  Address = "Address",
  Article = "Article",
  ArticleCategory = "ArticleCategory",
  ArticleParameter = "ArticleParameter",
  ArticlePrice = "ArticlePrice",
  ArticlePriceTier = "ArticlePriceTier",
  ArticleSource = "ArticleSource",
  Customer = "Customer",
  CustomerContact = "CustomerContact",
  CustomerOrder = "CustomerOrder",
  CustomerOrderPosition = "CustomerOrderPosition",
  DeliveryNote = "DeliveryNote",
  DeliveryNotePosition = "DeliveryNotePosition",
  Distributor = "Distributor",
  Footprint = "Footprint",
  FootprintMeta = "FootprintMeta",
  Position = "Position",
  InventoryEntry = "InventoryEntry",
  Invoice = "Invoice",
  InvoicePosition = "InvoicePosition",
  KeyField = "KeyField",
  Location = "Location",
  Offer = "Offer",
  OfferPosition = "OfferPosition",
  Order = "Order",
  OrderPosition = "OrderPosition",
  PNPFile = "PNPFile",
  PNPFileEntry = "PNPFileEntry",
  PaymentCondition = "PaymentCondition",
  Permission = "Permission",
  ProductGroup = "ProductGroup",
  Project = "Project",
  ProjectConfiguration = "ProjectConfiguration",
  Receipt = "Receipt",
  ReceiptPosition = "ReceiptPosition",
  Role = "Role",
  SupplyOrder = "SupplyOrder",
  SupplyOrderPosition = "SupplyOrderPosition",
  SupplyOrderReceipt = "SupplyOrderReceipt",
  User = "User",
}

export enum Transaction_Type {
  create = "create",
  update = "update",
  delete = "delete",
  add = "add",
  remove = "remove",
}

// datastructure: TransactionField
// no enums defined in this datastructure

// mutation input data types

// datastructure: Address
export interface CreateAddressInput {
  street: string;
  number: string;
  zip: number;
  state: string;
  country: string;
}

// datastructure: Address
export interface UpdateAddressInput {
  id: number;
  street?: string;
  number?: string;
  zip?: number;
  state?: string;
  country?: string;
}

// datastructure: Article
export interface CreateArticleInput {
  matchcode: string;
  name: string;
  display_name: string | null;
  description: string | null;
  footprint_id: number | null;
  inventory_type: Article_InventoryType | null;
  location_id: number | null;
  product_group_id: number | null;
  picture: string | null;
  datasheet_url: string | null;
  article_category_id: number | null;
}

// datastructure: Article
export interface UpdateArticleInput {
  id: number;
  matchcode?: string;
  name?: string;
  display_name?: string | null;
  description?: string | null;
  footprint_id?: number | null;
  inventory_type?: Article_InventoryType | null;
  location_id?: number | null;
  product_group_id?: number | null;
  picture?: string | null;
  datasheet_url?: string | null;
  article_category_id?: number | null;
}

// datastructure: ArticleCategory
export interface CreateArticleCategoryInput {
  name: string;
}

// datastructure: ArticleCategory
export interface UpdateArticleCategoryInput {
  id: number;
  name?: string;
}

// datastructure: ArticleParameter
export interface CreateArticleParameterInput {
  value: string;
  suffix: string;
  key_field_id: number;
  article_id: number;
}

// datastructure: ArticleParameter
export interface UpdateArticleParameterInput {
  id: number;
  value?: string;
  suffix?: string;
  key_field_id?: number;
  article_id?: number;
}

// datastructure: ArticlePrice
export interface CreateArticlePriceInput {
  article_id: number;
  article_price_tier_id: number;
  quantity: number;
  price: number;
}

// datastructure: ArticlePrice
export interface UpdateArticlePriceInput {
  id: number;
  article_id?: number;
  article_price_tier_id?: number;
  quantity?: number;
  price?: number;
}

// datastructure: ArticlePriceTier
export interface CreateArticlePriceTierInput {
  article_id: number;
  tier: number;
}

// datastructure: ArticlePriceTier
export interface UpdateArticlePriceTierInput {
  id: number;
  article_id?: number;
  tier?: number;
}

// datastructure: ArticleSource
export interface CreateArticleSourceInput {
  order_number: string;
  moq: number;
  url: string | null;
  quantity_scale: any | null;
  distributor_id: number;
  article_id: number;
}

// datastructure: ArticleSource
export interface UpdateArticleSourceInput {
  id: number;
  order_number?: string;
  moq?: number;
  url?: string | null;
  quantity_scale?: any | null;
  distributor_id?: number;
  article_id?: number;
}

// datastructure: Customer
export interface CreateCustomerInput {
  company: string | null;
  name: string | null;
  invoice_address_id: number | null;
  phone: string | null;
  email: string | null;
  payment_condition_id: number | null;
}

// datastructure: Customer
export interface UpdateCustomerInput {
  id: number;
  company?: string | null;
  name?: string | null;
  invoice_address_id?: number | null;
  phone?: string | null;
  email?: string | null;
  payment_condition_id?: number | null;
}

// datastructure: CustomerContact
export interface CreateCustomerContactInput {
  name: string | null;
  phone: string | null;
  email: string | null;
  customer_id: number;
}

// datastructure: CustomerContact
export interface UpdateCustomerContactInput {
  id: number;
  name?: string | null;
  phone?: string | null;
  email?: string | null;
  customer_id?: number;
}

// datastructure: CustomerOrder
export interface CreateCustomerOrderInput {
  customer_id: number | null;
  customer_name: string | null;
  customer_contact: string | null;
  customer_reference: string | null;
  notes: string | null;
  delivery_date: Date | null;
  state: CustomerOrder_State | null;
  type: CustomerOrder_Type;
  express: boolean | null;
  clerk_id: number | null;
}

// datastructure: CustomerOrder
export interface UpdateCustomerOrderInput {
  id: number;
  customer_id?: number | null;
  customer_name?: string | null;
  customer_contact?: string | null;
  customer_reference?: string | null;
  notes?: string | null;
  delivery_date?: Date | null;
  state?: CustomerOrder_State | null;
  type?: CustomerOrder_Type;
  express?: boolean | null;
  clerk_id?: number | null;
}

// datastructure: CustomerOrderPosition
export interface CreateCustomerOrderPositionInput {
  customer_order_id: number;
  quantity: number;
  price: number;
  text: string | null;
  distributor_id: number | null;
  order_number: string | null;
  type: CustomerOrderPosition_Type;
  article_id: number | null;
}

// datastructure: CustomerOrderPosition
export interface UpdateCustomerOrderPositionInput {
  id: number;
  customer_order_id?: number;
  quantity?: number;
  price?: number;
  text?: string | null;
  distributor_id?: number | null;
  order_number?: string | null;
  type?: CustomerOrderPosition_Type;
  article_id?: number | null;
}

// datastructure: DeliveryNote
export interface CreateDeliveryNoteInput {
  customer_id: number;
  customer_reference: string | null;
  order_id: number | null;
  invoice_id: number | null;
  notes: string | null;
  delivery_date: Date;
}

// datastructure: DeliveryNote
export interface UpdateDeliveryNoteInput {
  id: number;
  customer_id?: number;
  customer_reference?: string | null;
  order_id?: number | null;
  invoice_id?: number | null;
  notes?: string | null;
  delivery_date?: Date;
}

// datastructure: DeliveryNotePosition
export interface CreateDeliveryNotePositionInput {
  delivery_note_id: number;
  quantity: number;
  article_id: number | null;
  price: number;
  unit: string;
  text: string;
  index: number;
  type: DeliveryNotePosition_Type;
}

// datastructure: DeliveryNotePosition
export interface UpdateDeliveryNotePositionInput {
  id: number;
  delivery_note_id?: number;
  quantity?: number;
  article_id?: number | null;
  price?: number;
  unit?: string;
  text?: string;
  index?: number;
  type?: DeliveryNotePosition_Type;
}

// datastructure: Distributor
export interface CreateDistributorInput {
  name: string;
  short_name: string;
  search_url: string | null;
}

// datastructure: Distributor
export interface UpdateDistributorInput {
  id: number;
  name?: string;
  short_name?: string;
  search_url?: string | null;
}

// datastructure: Footprint
export interface CreateFootprintInput {
  name: string;
  type: Footprint_Type;
}

// datastructure: Footprint
export interface UpdateFootprintInput {
  id: number;
  name?: string;
  type?: Footprint_Type;
}

// datastructure: FootprintMeta
export interface CreateFootprintMetaInput {
  footprint_id: number;
  key: FootprintMeta_Key;
  value: string;
}

// datastructure: FootprintMeta
export interface UpdateFootprintMetaInput {
  id: number;
  footprint_id?: number;
  key?: FootprintMeta_Key;
  value?: string;
}

// datastructure: InventoryEntry
export interface CreateInventoryEntryInput {
  article_id: number;
  location_id: number;
  note: string | null;
  amount: number | null;
}

// datastructure: InventoryEntry
export interface UpdateInventoryEntryInput {
  id: number;
  article_id?: number;
  location_id?: number;
  note?: string | null;
  amount?: number | null;
}

// datastructure: Invoice
export interface CreateInvoiceInput {
  customer_id: number;
  customer_reference: string | null;
  related_order_id: number | null;
  related_delivery_note_id: number | null;
  notes: string | null;
  state: Invoice_State | null;
}

// datastructure: Invoice
export interface UpdateInvoiceInput {
  id: number;
  customer_id?: number;
  customer_reference?: string | null;
  related_order_id?: number | null;
  related_delivery_note_id?: number | null;
  notes?: string | null;
  state?: Invoice_State | null;
}

// datastructure: InvoicePosition
export interface CreateInvoicePositionInput {
  invoice_id: number;
  quantity: number;
  article_id: number | null;
  price: number;
  unit: string;
  text: string;
  index: number;
  type: InvoicePosition_Type;
}

// datastructure: InvoicePosition
export interface UpdateInvoicePositionInput {
  id: number;
  invoice_id?: number;
  quantity?: number;
  article_id?: number | null;
  price?: number;
  unit?: string;
  text?: string;
  index?: number;
  type?: InvoicePosition_Type;
}

// datastructure: KeyField
export interface CreateKeyFieldInput {
  name: string;
  article_category_id: number;
  type: KeyField_Type;
  unit: string | null;
  values: any | null;
  required: boolean | null;
}

// datastructure: KeyField
export interface UpdateKeyFieldInput {
  id: number;
  name?: string;
  article_category_id?: number;
  type?: KeyField_Type;
  unit?: string | null;
  values?: any | null;
  required?: boolean | null;
}

// datastructure: Location
export interface CreateLocationInput {
  name: string;
  parent_id: number | null;
}

// datastructure: Location
export interface UpdateLocationInput {
  id: number;
  name?: string;
  parent_id?: number | null;
}

// datastructure: Offer
export interface CreateOfferInput {
  customer_id: number;
  notes: string | null;
  delivery_date: Date;
}

// datastructure: Offer
export interface UpdateOfferInput {
  id: number;
  customer_id?: number;
  notes?: string | null;
  delivery_date?: Date;
}

// datastructure: OfferPosition
export interface CreateOfferPositionInput {
  offer_id: number;
  quantity: number;
  article_id: number | null;
  price: number;
  unit: string;
  text: string;
  index: number;
  type: OfferPosition_Type;
}

// datastructure: OfferPosition
export interface UpdateOfferPositionInput {
  id: number;
  offer_id?: number;
  quantity?: number;
  article_id?: number | null;
  price?: number;
  unit?: string;
  text?: string;
  index?: number;
  type?: OfferPosition_Type;
}

// datastructure: Order
export interface CreateOrderInput {
  customer_id: number;
  customer_reference: string | null;
  related_offer_id: number | null;
  related_order_id: number | null;
  order_type: Order_OrderType | null;
  notes: string | null;
  delivery_date: Date;
  state: Order_State | null;
  payment_condition_id: number;
}

// datastructure: Order
export interface UpdateOrderInput {
  id: number;
  customer_id?: number;
  customer_reference?: string | null;
  related_offer_id?: number | null;
  related_order_id?: number | null;
  order_type?: Order_OrderType | null;
  notes?: string | null;
  delivery_date?: Date;
  state?: Order_State | null;
  payment_condition_id?: number;
}

// datastructure: OrderPosition
export interface CreateOrderPositionInput {
  order_id: number;
  quantity: number;
  article_id: number | null;
  price: number;
  unit: string;
  text: string;
  index: number;
  type: OrderPosition_Type;
}

// datastructure: OrderPosition
export interface UpdateOrderPositionInput {
  id: number;
  order_id?: number;
  quantity?: number;
  article_id?: number | null;
  price?: number;
  unit?: string;
  text?: string;
  index?: number;
  type?: OrderPosition_Type;
}

// datastructure: PNPFile
export interface CreatePNPFileInput {
  filename: string;
  file_content: string;
  notes: string | null;
  ecad_unit: PnpFile_EcadUnit | null;
  pcb_size_x: number | null;
  pcb_size_y: number | null;
}

// datastructure: PNPFile
export interface UpdatePNPFileInput {
  id: number;
  filename?: string;
  file_content?: string;
  notes?: string | null;
  ecad_unit?: PnpFile_EcadUnit | null;
  pcb_size_x?: number | null;
  pcb_size_y?: number | null;
}

// datastructure: PNPFileEntry
export interface CreatePNPFileEntryInput {
  file_id: number;
  article_id: number;
  footprint_name: string;
  designator: string;
  comment: string;
  rotation: number;
  pos_x: number;
  pos_y: number;
  entry_mode: PnpFileEntry_EntryMode | null;
}

// datastructure: PNPFileEntry
export interface UpdatePNPFileEntryInput {
  id: number;
  file_id?: number;
  article_id?: number;
  footprint_name?: string;
  designator?: string;
  comment?: string;
  rotation?: number;
  pos_x?: number;
  pos_y?: number;
  entry_mode?: PnpFileEntry_EntryMode | null;
}

// datastructure: PaymentCondition
export interface CreatePaymentConditionInput {
  name: string;
  def: boolean | null;
  payment_plan: number;
  discount_days: number;
  discount_percent: number;
  invoice_text: string;
  other_text: string;
}

// datastructure: PaymentCondition
export interface UpdatePaymentConditionInput {
  id: number;
  name?: string;
  def?: boolean | null;
  payment_plan?: number;
  discount_days?: number;
  discount_percent?: number;
  invoice_text?: string;
  other_text?: string;
}

// datastructure: ProductGroup
export interface CreateProductGroupInput {
  name: string;
  parent_id: number | null;
}

// datastructure: ProductGroup
export interface UpdateProductGroupInput {
  id: number;
  name?: string;
  parent_id?: number | null;
}

// datastructure: Project
export interface CreateProjectInput {
  name: string;
  customer_id: number;
  notes: string | null;
}

// datastructure: Project
export interface UpdateProjectInput {
  id: number;
  name?: string;
  customer_id?: number;
  notes?: string | null;
}

// datastructure: ProjectConfiguration
export interface CreateProjectConfigurationInput {
  name: string;
  project_id: number;
  notes: string | null;
}

// datastructure: ProjectConfiguration
export interface UpdateProjectConfigurationInput {
  id: number;
  name?: string;
  project_id?: number;
  notes?: string | null;
}

// datastructure: Receipt
export interface CreateReceiptInput {
  customer_id: number | null;
  customer_name: string | null;
  customer_contact: string | null;
  customer_reference: string | null;
  notes: string | null;
}

// datastructure: Receipt
export interface UpdateReceiptInput {
  id: number;
  customer_id?: number | null;
  customer_name?: string | null;
  customer_contact?: string | null;
  customer_reference?: string | null;
  notes?: string | null;
}

// datastructure: ReceiptPosition
export interface CreateReceiptPositionInput {
  receipt_id: number;
  quantity: number;
  article_id: number | null;
  price: number;
  unit: string;
  text: string;
  index: number;
  type: ReceiptPosition_Type;
}

// datastructure: ReceiptPosition
export interface UpdateReceiptPositionInput {
  id: number;
  receipt_id?: number;
  quantity?: number;
  article_id?: number | null;
  price?: number;
  unit?: string;
  text?: string;
  index?: number;
  type?: ReceiptPosition_Type;
}

// datastructure: Role
export interface CreateRoleInput {
  name: string;
}

// datastructure: Role
export interface UpdateRoleInput {
  id: number;
  name?: string;
}

// datastructure: SupplyOrder
export interface CreateSupplyOrderInput {
  distributor_id: number;
  payment_reference: string | null;
  state: SupplyOrder_State | null;
}

// datastructure: SupplyOrder
export interface UpdateSupplyOrderInput {
  id: number;
  distributor_id?: number;
  payment_reference?: string | null;
  state?: SupplyOrder_State | null;
}

// datastructure: SupplyOrderPosition
export interface CreateSupplyOrderPositionInput {
  supply_order_id: number | null;
  supply_order_receipt_id: number | null;
  article_id: number;
  quantity: number;
  price: number;
  unit: string;
  canceled: boolean | null;
  date_of_delivery: Date | null;
}

// datastructure: SupplyOrderPosition
export interface UpdateSupplyOrderPositionInput {
  id: number;
  supply_order_id?: number | null;
  supply_order_receipt_id?: number | null;
  article_id?: number;
  quantity?: number;
  price?: number;
  unit?: string;
  canceled?: boolean | null;
  date_of_delivery?: Date | null;
}

// datastructure: SupplyOrderReceipt
export interface CreateSupplyOrderReceiptInput {
  buy_order_id: number;
}

// datastructure: SupplyOrderReceipt
export interface UpdateSupplyOrderReceiptInput {
  id: number;
  buy_order_id?: number;
}

// datastructure: Permission
export interface CreatePermissionInput {
  node: string;
}

// datastructure: Permission
export interface UpdatePermissionInput {
  id: number;
  node?: string;
}

// datastructure: User
export interface UpdateUserInput {
  id: number;
  displayname?: string | null;
  username?: string;
  email?: string;
}

// datastructure types

// datastructure: Address
export interface Address {
  id: number;
  street: string;
  number: string;
  zip: number;
  state: string;
  country: string;
  created_at: Date;
  updated_at: Date;
}

// datastructure: Article
export interface Article {
  id: number;
  matchcode: string;
  name: string;
  display_name: string | null;
  description: string | null;
  inventory_type: Article_InventoryType;
  picture: string | null;
  datasheet_url: string | null;
  inventory_entries: Array<InventoryEntry>;
  price_information: Array<ArticlePriceTier>;
  fields: Array<ArticleParameter>;
  sources: Array<ArticleSource>;
  customer_order_positions: Array<CustomerOrderPosition>;
  buyorder_positions: Array<SupplyOrderPosition>;
  footprint: Footprint | null;
  location: Location | null;
  product_group: ProductGroup | null;
  article_category: ArticleCategory | null;
  created_at: Date;
  updated_at: Date;
}

// datastructure: ArticleCategory
export interface ArticleCategory {
  id: number;
  name: string;
  fields: Array<KeyField>;
  articles: Array<Article>;
  created_at: Date;
  updated_at: Date;
}

// datastructure: ArticleParameter
export interface ArticleParameter {
  id: number;
  value: string;
  suffix: string;
  key_field: KeyField;
  article: Article;
  created_at: Date;
  updated_at: Date;
}

// datastructure: ArticlePrice
export interface ArticlePrice {
  id: number;
  quantity: number;
  price: number;
  article: Article;
  article_price_tier: ArticlePriceTier;
  created_at: Date;
  updated_at: Date;
}

// datastructure: ArticlePriceTier
export interface ArticlePriceTier {
  id: number;
  tier: number;
  prices: Array<ArticlePrice>;
  article: Article;
  created_at: Date;
  updated_at: Date;
}

// datastructure: ArticleSource
export interface ArticleSource {
  id: number;
  order_number: string;
  moq: number;
  url: string | null;
  quantity_scale: any;
  distributor: Distributor;
  article: Article;
  created_at: Date;
  updated_at: Date;
}

// datastructure: Customer
export interface Customer {
  id: number;
  company: string | null;
  name: string | null;
  phone: string | null;
  email: string | null;
  contacts: Array<CustomerContact>;
  projects: Array<Project>;
  customer_orders: Array<CustomerOrder>;
  delivery_notes: Array<DeliveryNote>;
  offers: Array<Offer>;
  orders: Array<Order>;
  invoices: Array<Invoice>;
  receipts: Array<Receipt>;
  invoice_address: Address | null;
  payment_condition: PaymentCondition | null;
  delivery_addresses: Array<Address>;
  created_at: Date;
  updated_at: Date;
}

// datastructure: CustomerContact
export interface CustomerContact {
  id: number;
  name: string | null;
  phone: string | null;
  email: string | null;
  customer: Customer;
  created_at: Date;
  updated_at: Date;
}

// datastructure: CustomerOrder
export interface CustomerOrder {
  id: number;
  customer_name: string | null;
  customer_contact: string | null;
  customer_reference: string | null;
  notes: string;
  delivery_date: Date | null;
  state: CustomerOrder_State;
  type: CustomerOrder_Type;
  express: boolean;
  positions: Array<CustomerOrderPosition>;
  customer: Customer | null;
  clerk: User | null;
  created_at: Date;
  updated_at: Date;
}

// datastructure: CustomerOrderPosition
export interface CustomerOrderPosition {
  id: number;
  quantity: number;
  price: number;
  text: string;
  order_number: string;
  type: CustomerOrderPosition_Type;
  customer_order: CustomerOrder;
  distributor: Distributor | null;
  article: Article | null;
  created_at: Date;
  updated_at: Date;
}

// datastructure: DeliveryNote
export interface DeliveryNote {
  id: number;
  customer_reference: string | null;
  notes: string;
  delivery_date: Date;
  positions: Array<DeliveryNotePosition>;
  customer: Customer;
  order: Order | null;
  invoice: Invoice | null;
  created_at: Date;
  updated_at: Date;
}

// datastructure: DeliveryNotePosition
export interface DeliveryNotePosition {
  id: number;
  quantity: number;
  price: number;
  unit: string;
  text: string;
  index: number;
  type: DeliveryNotePosition_Type;
  delivery_note: DeliveryNote;
  article: Article | null;
  created_at: Date;
  updated_at: Date;
}

// datastructure: Distributor
export interface Distributor {
  id: number;
  name: string;
  short_name: string;
  search_url: string | null;
  buy_orders: Array<SupplyOrder>;
  sources: Array<ArticleSource>;
  created_at: Date;
  updated_at: Date;
}

// datastructure: Footprint
export interface Footprint {
  id: number;
  name: string;
  type: Footprint_Type;
  meta: Array<FootprintMeta>;
  articles: Array<Article>;
  created_at: Date;
  updated_at: Date;
}

// datastructure: FootprintMeta
export interface FootprintMeta {
  id: number;
  key: FootprintMeta_Key;
  value: string;
  footprint: Footprint;
  created_at: Date;
  updated_at: Date;
}

// datastructure: InventoryEntry
export interface InventoryEntry {
  id: number;
  note: string | null;
  amount: number;
  article: Article;
  location: Location;
  created_at: Date;
  updated_at: Date;
}

// datastructure: Invoice
export interface Invoice {
  id: number;
  customer_reference: string | null;
  notes: string;
  state: Invoice_State;
  related_delivery_note: DeliveryNote;
  delivery_notes: Array<DeliveryNote>;
  positions: Array<InvoicePosition>;
  customer: Customer;
  related_order: Order | null;
  created_at: Date;
  updated_at: Date;
}

// datastructure: InvoicePosition
export interface InvoicePosition {
  id: number;
  quantity: number;
  price: number;
  unit: string;
  text: string;
  index: number;
  type: InvoicePosition_Type;
  invoice: Invoice;
  article: Article | null;
  created_at: Date;
  updated_at: Date;
}

// datastructure: KeyField
export interface KeyField {
  id: number;
  name: string;
  type: KeyField_Type;
  unit: string | null;
  values: any | null;
  required: boolean;
  article_category: ArticleCategory;
  created_at: Date;
  updated_at: Date;
}

// datastructure: Location
export interface Location {
  id: number;
  name: string;
  children: Array<Location>;
  inventory_entries: Array<InventoryEntry>;
  articles: Array<Article>;
  parent: Location | null;
  created_at: Date;
  updated_at: Date;
}

// datastructure: Offer
export interface Offer {
  id: number;
  notes: string;
  delivery_date: Date;
  positions: Array<OfferPosition>;
  customer: Customer;
  created_at: Date;
  updated_at: Date;
}

// datastructure: OfferPosition
export interface OfferPosition {
  id: number;
  quantity: number;
  price: number;
  unit: string;
  text: string;
  index: number;
  type: OfferPosition_Type;
  offer: Offer;
  article: Article | null;
  created_at: Date;
  updated_at: Date;
}

// datastructure: Order
export interface Order {
  id: number;
  customer_reference: string | null;
  order_type: Order_OrderType;
  notes: string;
  delivery_date: Date;
  state: Order_State;
  orders: Array<Order>;
  delivery_notes: Array<DeliveryNote>;
  invoices: Array<Invoice>;
  positions: Array<OrderPosition>;
  customer: Customer;
  related_offer: Offer | null;
  related_order: Order | null;
  payment_condition: PaymentCondition;
  created_at: Date;
  updated_at: Date;
}

// datastructure: OrderPosition
export interface OrderPosition {
  id: number;
  quantity: number;
  price: number;
  unit: string;
  text: string;
  index: number;
  type: OrderPosition_Type;
  order: Order;
  article: Article | null;
  created_at: Date;
  updated_at: Date;
}

// datastructure: PNPFile
export interface PNPFile {
  id: number;
  filename: string;
  file_content: string;
  notes: string;
  ecad_unit: PnpFile_EcadUnit;
  pcb_size_x: number;
  pcb_size_y: number;
  entries: Array<PNPFileEntry>;
  created_at: Date;
  updated_at: Date;
}

// datastructure: PNPFileEntry
export interface PNPFileEntry {
  id: number;
  footprint_name: string;
  designator: string;
  comment: string;
  rotation: number;
  pos_x: number;
  pos_y: number;
  entry_mode: PnpFileEntry_EntryMode;
  file: PNPFile;
  article: Article;
  created_at: Date;
  updated_at: Date;
}

// datastructure: PaymentCondition
export interface PaymentCondition {
  id: number;
  name: string;
  def: boolean;
  payment_plan: number;
  discount_days: number;
  discount_percent: number;
  invoice_text: string;
  other_text: string;
  created_at: Date;
  updated_at: Date;
}

// datastructure: ProductGroup
export interface ProductGroup {
  id: number;
  name: string;
  children: Array<ProductGroup>;
  articles: Array<Article>;
  parent: ProductGroup | null;
  created_at: Date;
  updated_at: Date;
}

// datastructure: Project
export interface Project {
  id: number;
  name: string;
  notes: string;
  project_configurations: Array<ProjectConfiguration>;
  customer: Customer;
  created_at: Date;
  updated_at: Date;
}

// datastructure: ProjectConfiguration
export interface ProjectConfiguration {
  id: number;
  name: string;
  notes: string;
  project: Project;
  created_at: Date;
  updated_at: Date;
}

// datastructure: Receipt
export interface Receipt {
  id: number;
  customer_name: string | null;
  customer_contact: string | null;
  customer_reference: string | null;
  notes: string;
  positions: Array<ReceiptPosition>;
  customer: Customer | null;
  created_at: Date;
  updated_at: Date;
}

// datastructure: ReceiptPosition
export interface ReceiptPosition {
  id: number;
  quantity: number;
  price: number;
  unit: string;
  text: string;
  index: number;
  type: ReceiptPosition_Type;
  receipt: Receipt;
  article: Article | null;
  created_at: Date;
  updated_at: Date;
}

// datastructure: Role
export interface Role {
  id: number;
  name: string;
  users: Array<User>;
  permissions: Array<Permission>;
  created_at: Date;
  updated_at: Date;
}

// datastructure: SupplyOrder
export interface SupplyOrder {
  id: number;
  payment_reference: string | null;
  state: SupplyOrder_State;
  positions: Array<SupplyOrderPosition>;
  receipts: Array<SupplyOrderReceipt>;
  distributor: Distributor;
  created_at: Date;
  updated_at: Date;
}

// datastructure: SupplyOrderPosition
export interface SupplyOrderPosition {
  id: number;
  quantity: number;
  price: number;
  unit: string;
  canceled: boolean;
  date_of_delivery: Date;
  supply_order: SupplyOrder | null;
  supply_order_receipt: SupplyOrderReceipt | null;
  article: Article;
  created_at: Date;
  updated_at: Date;
}

// datastructure: SupplyOrderReceipt
export interface SupplyOrderReceipt {
  id: number;
  positions: Array<SupplyOrderPosition>;
  buy_order: SupplyOrder;
  created_at: Date;
  updated_at: Date;
}

// datastructure: Permission
export interface Permission {
  id: number;
  node: string;
  users: Array<User>;
  roles: Array<Role>;
  created_at: Date;
  updated_at: Date;
}

// datastructure: User
export interface User {
  id: number;
  displayname: string | null;
  username: string;
  email: string;
  transactions: Array<Transaction>;
  customer_orders: Array<CustomerOrder>;
  roles: Array<Role>;
  permissions: Array<Permission>;
  created_at: Date;
  updated_at: Date;
}

// datastructure: Transaction
export interface Transaction {
  id: number;
  object_type: Transaction_ObjectType;
  type: Transaction_Type;
  fields: Array<TransactionField>;
  owner: User | null;
  created_at: Date;
  updated_at: Date;
}

// datastructure: TransactionField
export interface TransactionField {
  id: number;
  key: string;
  value: string | null;
  transaction: Transaction;
  created_at: Date;
  updated_at: Date;
}
